import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
var SubMenu = function SubMenu() {
  return import('@/components/molecules/SubMenu');
};
export default {
  data: function data() {
    return {
      isVolumeSliderOn: false
    };
  },
  computed: {
    isSound: function isSound() {
      return useSoundStatus().IsSoundOn;
    },
    isVolumeSlider: function isVolumeSlider() {
      return this.isVolumeSliderOn;
    },
    volume: {
      get: function get() {
        return useSoundStatus().SoundVolume;
      },
      set: function set(value) {
        if (useSoundStatus().SoundVolume <= 0.0) {
          useSoundStatus().volumeSetting(value);
          this.$soundService.stopAll();
          this.$soundService.playMainBgm();
        } else {
          useSoundStatus().volumeSetting(value);
        }
      }
    }
  },
  methods: {
    onToggleVolume: function onToggleVolume() {
      this.isVolumeSliderOn = !this.isVolumeSliderOn;
    }
  }
};